import { gql } from '@apollo/client'

import { FRAGMENT_FILE_STORAGE_STATISTICS } from './fragments'

export const GET_STORAGE_INFO_QUERY = gql`
  query getStorageInfo {
    getWorkspace {
      id
      fileStorage {
        ...FragmentFileStorageStatistics
      }
    }
  }
  ${FRAGMENT_FILE_STORAGE_STATISTICS}
`

export const GET_DOCUMENTS_LIST_QUERY = gql`
  query getDocumentsList($take: Int!, $cursor: String, $status: [FileStorageStatus!]) {
    getWorkspace {
      id
      fileStorage {
        filesPaginated(take: $take, cursor: $cursor, status: $status) {
          cursor
          totalCount
          data {
            fileName
            id
            size
            createdAt
            status
          }
        }
        ...FragmentFileStorageStatistics
      }
    }
  }
  ${FRAGMENT_FILE_STORAGE_STATISTICS}
`

export const UPLOAD_DOCUMENT_AND_GET_PRESIGNED_URL_MUTATION = gql`
  mutation uploadDocumentAndGetPresignedUrl($files: [FileStorageFileUploadRequestInput!]!) {
    createFileStorageUploadUrls(input: { files: $files }) {
      uploads {
        id
        uploadUrl
        fields {
          value
          key
        }
      }
    }
  }
`

export const DELETE_DOCUMENT_MUTATION = gql`
  mutation deleteDocument($fileId: String!) {
    deleteFileStorageFile(input: { id: $fileId }) {
      success
    }
  }
`
